import AOS from 'aos';
import 'aos/dist/aos.css';
import React from 'react';
import { Link } from 'react-router-dom';
import { Typewriter } from 'react-simple-typewriter';
import '../../CSS/Bird.css';

AOS.init({
  duration: '2000'
});

const Landing = () => {
  return (
    <section className="landing">
      <div className="landing-inner ">

        <div className='all-birds-container'>
          <div className="bird-container bird-container-one">
            <div className="bird bird-one"></div>
          </div>
          <div className="bird-container bird-container-two">
            <div className="bird bird-two"></div>
          </div>
          <div className="bird-container bird-container-three">
            <div className="bird bird-three"></div>
          </div>
          <div className="bird-container bird-container-four">
            <div className="bird bird-four"></div>
          </div>
        </div>

        <div>
          <h1 style={{ color: "white", fontSize: "100px", textShadow: "2px 2px #dcb103" }} data-aos='zoom-in'> GharBar </h1>
          <p className = "lead" style={{ color: "white", paddingTop: ".5rem"}} data-aos='zoom-out'> अतिथि देवो भवः </p>
          <p className='lead text-light'> {
            <Typewriter
              words={["Homestay and Suite","Banquet and Conference Hall", "Food and Bar"]}
              loop={5}
              cursor
              cursorStyle='|'
              typeSpeed={60}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          }
          </p>
          {/* <p className='lead text-light'> {
            <Typed strings={[
              "Homestay and Suite",
              "Banquet and Conference Hall",
              "Food and Bar",
              ]}
              typeSpeed={40}
              backSpeed={40}
              loop
            />}
          </p> */}
          <div style={{ "marginTop": "2rem" }}>
            <Link to='/homescreen'><button type="button" class="btn btn-warning">Get Started</button></Link>
          </div>
        </div>

      </div>
    </section>
  )
};

export default Landing;